

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getUserInfo,
  getDistributionActById,
  getDistributionInvitData,
  getDistributionActSettings
} from "@/api";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";
import UserTable from "@/components/UserTable.vue";
import {
  IActivity,
  IMyBuyInfo,
  IMyFollowInfo,
  IPageParams,
  IRankUser
} from "@/types";
import MyWxJs, { wx as wechat } from "@/utils/wx.ts";
import { jumpToCourse } from "@/utils/index.ts";

// enum EStatus {
//   opened = "opened",
//   closed = "closed"
// }
// enum ERankType {
//   follow = "follow",
//   buy = "buy"
// }
interface userInfoParams {
  userCount: number;
  userList: Array<any>;
}

@Component({
  components: {
    MyFooter,
    Rule,
    UserTable
  }
})
export default class My extends Vue {
  $refs!: {
    scroll: HTMLElement;
    // end: HTMLElement;
  };
  @Prop({ type: Number, required: true }) distributionId!: number;
  // ERankType = ERankType;
  loading: boolean = true;
  // type: ERankType = ERankType.follow;
  activity: IActivity = {
    configurationText: {
      banner: {}
    }
  } as IActivity;
  pageConfig = {
    banner: "",
    bannerTitle: "",
    h5Title: "",
    rule: ""
  };
  invitUserInfo: userInfoParams = {
    userCount: 0,
    userList: []
  };

  buyUserInfo: userInfoParams = {
    userCount: 0,
    userList: []
  };

  buyPageParams = {
    page: 0,
    limit: 10,
    loading: false,
    end: false
  };
  invitPageParams = {
    page: 0,
    limit: 10,
    loading: false,
    end: false
  };

  async created() {
    const config = await MyWxJs.getWxConfig();
    wechat.config(config);
  }

  async mounted() {
    const userInfo = await getUserInfo();
    const config = await getDistributionActById(this["distributionId"]);
    this["setWechatShare"](
      Object.assign({}, config, { userId: userInfo.userId })
    );
  }

  get buyCourseInfo() {
    const info = {
      title: `${this.buyUserInfo.userCount}人已购买`,
      emptyTips: "进度为0，快去邀请小伙伴学习课程吧～"
    };
    return info;
  }
  get buyInvitationInfo() {
    return {
      title: `共邀请了${this.invitUserInfo.userCount}人`,
      emptyTips: "进度为0，快去邀请小伙伴学习课程吧~"
    };
  }

  async getPurchasesData() {
    if (this.buyPageParams.loading || this.buyPageParams.end) return;
    this.buyPageParams.loading = true;
    try {
      const { rows, count } = await getDistributionInvitData({
        distributionId: this.distributionId,
        type: "purchases",
        needCount: 1,
        order: "id,asc",
        limit: this.buyPageParams.limit,
        page: this.buyPageParams.page
      });
      this.buyUserInfo.userCount = count || 0;
      this.buyUserInfo.userList.push(...(rows || []));
      this.buyPageParams.page++;
      if (
        this.buyPageParams.page * this.buyPageParams.limit >=
        this.buyUserInfo.userCount
      )
        this.buyPageParams.end = true;
    } catch (error) {
      console.error(error);
    }
    this.buyPageParams.loading = false;
  }

  async getInvitData() {
    if (this.invitPageParams.loading || this.invitPageParams.end) return;
    this.invitPageParams.loading = true;
    try {
      const { rows, count } = await getDistributionInvitData({
        distributionId: this.distributionId,
        needCount: 1,
        order: "id,asc",
        limit: this.invitPageParams.limit,
        page: this.invitPageParams.page
      });
      this.invitUserInfo.userCount = count || 0;
      this.invitUserInfo.userList.push(...(rows || []));
      this.invitPageParams.page++;
      if (
        this.invitPageParams.page * this.invitPageParams.limit >=
        this.invitUserInfo.userCount
      )
        this.invitPageParams.end = true;
    } catch (error) {
      console.error(error);
    }
    this.invitPageParams.loading = false;
  }

  @Watch("distributionId", { immediate: true })
  async getDistributionInvitData() {
    this.loading = true;
    await this.getPageConfig();
    try {
      await this.getPurchasesData();
    } catch (error) {
      console.error(error);
    }
    try {
      await this.getInvitData();
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  async getPageConfig() {
    try {
      const pageConfig = await getDistributionActSettings(this.distributionId);
      if (pageConfig) {
        if (pageConfig.h5Title) {
          document.title = pageConfig.h5Title;
          if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
            var i = document.createElement("iframe");
            i.src = "/favicon.ico";
            i.style.display = "none";
            i.onload = function() {
              setTimeout(function() {
                i.remove();
              }, 9);
            };
            document.body.appendChild(i);
          }
        }
        this.pageConfig = pageConfig;
        this.$rulePopup({
          value: false,
          rule: pageConfig.rule
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  // 设置微信分享
  setWechatShare(data: any) {
    console.log("data----------", data);
    if (data.shareSettings && data.shareSettings.imgurl) {
      data.shareSettings.imgUrl = data.shareSettings.imgurl;
    }
    let timelineShare = data.shareSettings || {};
    let wxMessageShare = data.shareSettings || {};

    timelineShare = Object.assign(
      {
        title: data.title,
        link: window.location.href,
        imgUrl: "https://app-cdn.btclass.cn/logo-book%202.png"
      },
      timelineShare
    );

    wxMessageShare = Object.assign(
      {
        title: "BT教育",
        desc: data.title,
        link: window.location.href,
        imgUrl: "https://app-cdn.btclass.cn/logo-book%202.png"
      },
      wxMessageShare
    );

    const shareUrl = jumpToCourse({
      courseId: data.courseIds[0],
      distributionId: this.distributionId,
      inviteUserId: data.userId
    });
    timelineShare.link = shareUrl;
    wxMessageShare.link = shareUrl;

    wechat.ready(() => {
      console.log(
        "wechat ready",
        "shareUrl",
        timelineShare.link,
        wxMessageShare.link
      );
      wechat.onMenuShareTimeline(timelineShare);
      wechat.onMenuShareAppMessage(wxMessageShare);
    });
  }
}
